<template>
  <div class="accountDeptAssign">
    <!-- 部分设置弹窗 -->
    <el-dialog class="dialog816" title="指派角色" :visible.sync="isRoleDialogShow">
      <el-table
        :data="roleList"
        highlight-current-row
        :height="630"
        size="mini"
        fit
        :close-on-click-modal="false"
      >
        <el-table-column prop="roleName" label="指派角色" :show-overflow-tooltip="true">
          <template slot-scope="props">
            <el-radio v-model="roleCode" :label="props.row.roleCode" disabled>&nbsp;</el-radio>
          </template>
        </el-table-column>
        <el-table-column prop="roleName" label="角色名称" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="roleName" label="默认角色" :show-overflow-tooltip="true">
          <template slot-scope="props">
            <el-radio v-model="roleCode" :label="props.row.roleCode">&nbsp;</el-radio>
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button type="info" @click="isRoleDialogShow=false">取 消</el-button>
        <el-button type="primary" @click="saveClick()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getAllRolesService,
  addUserRoleService
} from "../../services/sysSettingService";
import { getAreaListByDeptCodeService } from "../../services/commonService";
export default {
  name: "accountDeptAssign",
  data() {
    return {
      roleList: [], //角色数组
      isRoleDialogShow: false, //显示开关
      userCode: "", //用户id
      userDeptKeys: [], //用户授权的组织
      deptCheckedKeys: [], //选中的组织
      deptHalfCheckedKeys: [], //半选中的组织
      userDeptNodes: [],
      roleCode: "",
      defaultProps: {
        label: "text",
        children: "children",
        value: "id"
      }
    };
  },
  methods: {
    /* 父组件调用，刷新内容 */
    refreshMenu(userCode,roleCode) {
      this.isRoleDialogShow = true;
      this.userCode = userCode;
      this.roleCode = roleCode;
      this.getAllRoles();
    },
    /* 获取用户列表 */
    getAllRoles() {
      let reqParam={
        userCode : this.userCode
      }
      getAllRolesService(reqParam).then(
        res => {
          if (res.resultCode == 0) {
            this.roleList = res.data.list;
          }
        },
        err => {
          this.$message.error("网络请求失败");
        }
      );
    },
    /* 保存按钮回调 */
    saveClick() {
      if(this.roleCode ==null){
        this.$message.error('请选择用户角色');
        return;
      }
      //组装参数
      this.addUserRole();
    },

    /* 用户授权回调 */
    addUserRole() {
      let reqParam = {
        userCode: this.userCode,
        roleCode: this.roleCode,
        operationFlag: 0
      };
      addUserRoleService(reqParam).then(
        res => {
          console.log(res);
          if (res.resultCode == 0) {
            this.$alert("角色授权成功", "提示");
            this.isRoleDialogShow = false;
          }
        },
        err => {
          this.$message.error("网络请求失败");
        }
      );
    }
  }
};
</script>

<style scoped lang="scss">
.accountDeptAssign {
  // height: 100%;
  background-color: white;
  .el-table {
    height: 100% !important;
    overflow: auto;
    /deep/.cell {
      text-align: center;
    }
  }
  .el-footer {
    text-align: right;
  }
  /deep/.el-dialog__body {
    height: 500px;
  }
}
</style>
